import { useEffect, useState } from "react";
import { useLang } from "../i18n/LanguageContext";

export const Header = () => {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { id: "story", label: t.nav.journey },
    { id: "table", label: t.nav.table },
    { id: "tiers", label: t.nav.tiers },
    { id: "boarding", label: t.nav.reserve },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#f9f6f0]/85 border-b border-[#e5d9c5]/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        {/* Logo / brand */}
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
        >
          <span className="font-mono-utility text-[10px] tracking-[0.3em] text-[#a64b2a] uppercase">
            ASS · 06
          </span>
          <span className="hidden sm:inline-block w-px h-4 bg-[#e5d9c5]" />
          <span className="font-serif-display text-lg md:text-xl text-[#2c1e16] tracking-tight">
            Afro-Swiss <em className="text-[#a64b2a] not-italic">·</em> Soul Food
          </span>
        </a>

        {/* Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`nav-${item.id}`}
              className="link-underline text-sm font-light text-[#2c1e16]/80 hover:text-[#2c1e16] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Language toggle */}
        <div
          data-testid="lang-toggle"
          className="inline-flex items-center rounded-full border border-[#e5d9c5] bg-[#f9f6f0]/60 backdrop-blur p-0.5"
        >
          {["en", "de"].map((l) => (
            <button
              key={l}
              data-testid={`lang-${l}`}
              onClick={() => setLang(l)}
              className={`px-3 py-1 text-xs font-mono-utility tracking-widest rounded-full transition-all ${
                lang === l
                  ? "bg-[#2c1e16] text-[#f9f6f0]"
                  : "text-[#2c1e16]/60 hover:text-[#2c1e16]"
              }`}
            >
              {t.lang[l]}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
};
